import { AfterViewInit, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEmployerFormFactory } from '../../../employers/add-employer/utils/add-employer-form-factory';
import { map, startWith } from 'rxjs/operators';
import { PhoneDropdownItem } from '../../../../models/shared/phone-dropdown-item';
import { TypeService } from '../../../../services/type/type-service';
import { Subscribable } from '../../../../models/base/subscribable';

@Component({
  selector: 'app-employer-record-add-additional-contact-modal',
  templateUrl: './employer-record-add-additional-contact-modal.component.html',
  styleUrls: ['./employer-record-add-additional-contact-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordAddAdditionalContactModalComponent extends Subscribable implements AfterViewInit {
  private ngbModal = inject(NgbActiveModal);
  private typeService = inject(TypeService);

  public formGroup = AddEmployerFormFactory.createEmployerAdditionalContactFormGroup();
  public formSubmitted = false;

  public countryCodeDropdowns$ = this.typeService.countries$.pipe(
    map(countries => countries?.map(c => new PhoneDropdownItem(c)))
  );

  public maskitoOptions = {
    contactTopic: {
      mask: /^.{0,40}$/
    }
  };

  public customErrorMessages = {
    firstName: {
      required: $localize`First Name required`
    },
    lastName: {
      required: $localize`Last Name required`
    },
    jobTitle: {
      required: $localize`Job Title required`
    },
    phoneNumber: {
      required: $localize`Phone Number required`
    },
    email: {
      required: $localize`Email required`
    },
    contactTopic: {
      required: $localize`Contact Topic required`,
      maxlength: $localize`Contact Topic must be no more than 40 characters`
    }
  };

  private initializeFormListeners(): void {
    this.formGroup.controls.hasSigningAuthority.valueChanges.pipe(startWith(false)).subscribeWhileAlive({
      owner: this,
      next: hasSigningAuthority => {
        if (hasSigningAuthority) {
          this.formGroup.controls.address.enable();
        } else {
          this.formGroup.controls.address.disable();
        }
      }
    });
  }

  public ngAfterViewInit(): void {
    this.initializeFormListeners();
  }

  public cancel(): void {
    this.ngbModal.close();
  }

  public addContact(): void {
    this.formSubmitted = true;

    if (this.formGroup.valid) {
      this.ngbModal.close(this.formGroup);
    }
  }
}
